export function AnimalCardComponentInstructions() {
    return (
        <>
            <span className='bg-white rounded-md m-4 p-3 text-xl font-normal font-sans  w-fit mx-auto float-left shadow-black shadow-sm'>Click the left side of the image to backtrack</span>
            <span className='bg-white w-fit rounded-md m-4 p-3 text-xl font-normal font-sans float-right shadow-black shadow-sm'>Click the right side of the image to see a new image</span>
        </>
    )
}